import styled from 'styled-components';
import { Flex } from 'antd';
import { Heading, Paragraph } from '../Ant';

const NoDataWrapper = styled(Flex)`
  height: 50%;
  .icon {
    font-size: 70px;
    color: var(--clr-icon-color);
  }
`;

const NoData = ({
  header,
  subHeader,
  icon,
  gap = 12,
}: {
  header: string;
  subHeader?: string;
  icon: React.ReactNode;
  gap?: number;
}) => {
  return (
    <NoDataWrapper align="center" vertical gap={gap} justify="center" data-testid="no-data-wrapper">
      <span aria-hidden="true" className="d-flex">
        {icon}
      </span>
      <Flex vertical gap={4} align="center">
        <Heading
          data-testid="no-data-header"
          level={6}
          $fontsize="16px"
          $lineheight="22px"
          $color="title"
          $weight={600}
        >
          {header}
        </Heading>
        <Paragraph
          data-testid="no-data-subheader"
          $fontsize="12px"
          $lineheight="20px"
          $color="description"
          className="ta-center"
        >
          {subHeader}
        </Paragraph>
      </Flex>
    </NoDataWrapper>
  );
};

export default NoData;
